import { getActiveMaintenancePeriods } from "../services/vu"

export const fetchMaintenancePeriods = () => {
    return (dispatch) => { 
        dispatch(requestMaintenancePeriod());

        return getActiveMaintenancePeriods().then((maintenancePeriods = []) => {
            let response;
            if (maintenancePeriods.length > 0) {
                let endTime =  maintenancePeriods[0].attributes.dateRange.endValue;
                let startTime =  maintenancePeriods[0].attributes.dateRange.value;
                let currentTime = Math.floor(new Date().getTime()/1000);

                response = {
                    isClosedForMaintenance: endTime > currentTime && (currentTime > startTime || currentTime == startTime ),
                    maintenancePeriod: {
                            title: maintenancePeriods[0].attributes.title,
                            outageMessage: maintenancePeriods[0].attributes.body.value,
                            dateRange: maintenancePeriods[0].attributes.dateRange,
                            outageAlertTitle: maintenancePeriods[0].attributes.outageAlertTitle,
                            outageAlertMessage: maintenancePeriods[0].attributes.outageAlertMessage.value
                        }
                }
            }
            return dispatch(receiveMaintenancePeriods(response))
        })
    }
}

const requestMaintenancePeriod = () => {
    return { 
        type: 'FETCH_MAINTENANCE_PERIODS' 
    }
}

const receiveMaintenancePeriods = (data) => {
    return {
        type: 'RECEIVE_MAINTENANCE_PERIODS',
        data
    }
}
